export default __webpack_public_path__ + "static/media/checkout-empty.6fd5c5d1.svg";